/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_Usage_Private_ModelsInputs */



/**
* | output |
* | --- |
* | "Use private or self-hosted models" |
*
* @param {Onboarding_Usage_Private_ModelsInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const onboarding_usage_private_models = /** @type {((inputs?: Onboarding_Usage_Private_ModelsInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_Usage_Private_ModelsInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Private oder selbst gehostete Modelle nutzen")
	return /** @type {LocalizedString} */ ("Use private or self-hosted models")
});